export const options = {
  domainMax: 100,
  dots: true,
  height: 292,
  tooltip: true,
  domainCalc: true,
  dataXFormat: 'month',
  dataYFormat: 'percent'
};
